import React,{useEffect,useState,useContext,useRef} from 'react'
import axios from 'axios'
import alertify from 'alertifyjs';
import Dropzone from 'react-dropzone'
import 'alertifyjs/build/css/alertify.css';
import LoginModal from '../Modals/LoginModal';
import SingleImageProcessing from './SingleImageProcessing';
import BulkImageProcessing from './BulkImageProcessing';
import Slider from "react-slick";
import Styles from '../../Css/UploadScreen.module.css'
import styles from '../../Css/CustomSettings.module.css'
import '../../Css/Common.css'
import { ContextConsumer, AuthContext } from '../../context/GlobalState'
import {Helmet} from "react-helmet";
import * as Sentry from "@sentry/react"
import FabricCropModal from '../Modals/FabricCropModal';
import {fetchCreditUserDetails, updateUserCredit,cookie,poll, chunkArrayWhiteoutCorrection} from '../Common/Utils'
import FreeHandCropping from '../Modals/FreeHandCropping';
import posthog from 'posthog-js';
import {connect} from 'react-redux'

// posthog.init("phc_p92egRlXhuEzPYkMaQVakJl0XCI82X507N84clTaJHH", {api_host: 'https://app.posthog.com'});
posthog.init("FoIzpWdbY_I9T_4jr5k4zzNuVJPcpzs_mIpO6y7581M", {api_host: 'https://app.posthog.com'});

// Slider Script Start
function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }

function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={"slider-icon-left"}
        style={{ ...style, display: "inline-block"}}
        onClick={onClick}
      >
           <i class="fa fa-angle-double-left"></i></div>
    );
  }
  
  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={"slider-icon " } 
        style={{ ...style, display: "inline-block" }}
        onClick={onClick}
      >
          <i class="fa fa-angle-double-right"></i>
      </div>
    );
  }
 // Slider script End  

function UploadScreen(props) {

    const [random,setRandom] = useState('');
    useEffect(() => {
        var characters = "ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";
        var lenString = 7; 
        var randomstring = '';
        for (var i=0; i<lenString; i++) {  
            var rnum = Math.floor(Math.random() * characters.length);  
            randomstring += characters.substring(rnum, rnum+1);  
        }
        setRandom(`${randomstring}`)
        
        
    },[])
    if(!JSON.parse(sessionStorage.getItem(`isImageHide`))){
        // sessionStorage.clear()
        sessionStorage.removeItem('project_name')
        sessionStorage.removeItem('sku_name')
        sessionStorage.removeItem('isImageHide')
        sessionStorage.removeItem('isImageUploaded')
        sessionStorage.removeItem(`${random}isZipReady`)
        sessionStorage.removeItem(`${random}uploadStarted`)
        window.localStorage.removeItem('fileList')
        
    }
    

        

    const cookie = key=>((new RegExp((key || '=')+'=(.*?); ','gm')).exec(document.cookie+'; ') ||['',null])[1]

    const [themeColor, setThemeColor] = useState('')
    const [enterpriseName,setEnterpriseName] = useState('')
    const [favIcon,setFavIcon] = useState('') 
    const [fileList, setFileList] = useState(sessionStorage.getItem(`isImageHide`) ? JSON.parse(window.localStorage.getItem(`${random}fileList`)) :[])
    const [isBulk, setIsBulk] = useState(null)
    const [maxUpload, setMaxUpload] = useState(false)
    const [sampleImages, setSampleImages] = useState([])
    const [isSampleImage, setIsSampleImage] = useState(false)
    const [isImageUploaded,setIsImageUploaded] =useState(sessionStorage.getItem(`isImageHide`) ? window.sessionStorage.getItem(`isImageUploaded`) :false)


    const [isLoggedIn, setIsLoggedIn] = useState(false)
    const [availableCredit,setAvailableCredit] = useState(0)
    const [allotedCredit,setAllotedCredit] = useState(0)
    const [usedCredit,setUsedCredit] = useState(0)
    const [category,setCategory] = useState(null)
    const [prodCatId,setProdCatId] = useState('')
    const [prodSubCatId,setProdSubCatId] = useState(null)
    const [frontendData, setFrontendData] = useState('')
    const [isThreeDRendering, setIsThreeDRendering] = useState(false)
    const [categoryType, setCategoryType] = useState('')
    const [subCatName, setSubCatName] = useState('')
    const [imgGenerationList, setImgGenerationList] = useState(JSON.parse(window.sessionStorage.getItem(`imgGenerationList`)) ? JSON.parse(window.sessionStorage.getItem(`imgGenerationList`)) :[])
    const [kurtiImg, setKurtiImg] = useState('')
    const [dupattaImg,setDupattaImg] = useState('')
    const [salwarImg,setSalwarImg] = useState('')

    const [showLoginModal,setShowLoginModal] = useState(false)
    const [showInstruction,setShowInstruction] = useState(false)
    const [dropBackground, setDropBackground] = useState(false)
    const [beforeCredits,setBeforeCredits] = useState(0)
    const [showFabricCropModal, setShowFabricCropModal] = useState(false)
    const [downloadDone, setDownloadDone] = useState(false)
    const [reduxSingleProcessData, setReduxSingleProcessData] = useState({isFromRedux: false, imgURL:'', file:{}})
    const [uploadLogin, setUploadLogin] = useState(false);
    const handleCroppedFabric = (e) => {

        let file = {
            file: e,
            name: e.name,
            size: e.size,
            type: e.type,
            lastModified: e.lastModified,
            lastModifiedDate: e.lastModifiedDate,
            url: URL.createObjectURL(e),
            status: 'Uploading',
            imageId: null,
            outputImgUrl: null,
            projectId: null,
            skuId:null,
            fullScreenOutput:null,
        }
       
        setFileList([file])

        
    }
 
 
    const fabrics = [
        {
            'img':'https://storage.googleapis.com/spyne-website/self-serve/saree-1.png',
            'name':'Saree',
            'type':'live',
            'url' : '/category/fabric/saree/try'
        },
        {
            'img':'https://storage.googleapis.com/spyne-website/self-serve/suit.png',
            'name':'Suit',
            'type':'live',
            'url' : '/category/fabric/suit/try'
        }
    ]

    const homeFurnishing = [
        {
            'img':'https://storage.googleapis.com/spyne-website/self-serve/bedsheet.png',
            'name':'Bedsheet',
            'type':'live',
            'url' : '/category/home-furnishing/bedsheet/try'
        },
        {
            'img':'https://storage.googleapis.com/spyne-website/self-serve/curtain-1.png',
            'name':'Curtain',
            'type':'live',
            'url' : '/category/home-furnishing/curtains/try'
        },
        {
            'img':'https://storage.googleapis.com/spyne-website/static/website-themes/clippr/static/cushion-self-serve.png',
            'name':'Cushion',
            'type':'live',
            'url' : '/category/home-furnishing/cushions/try'
        }
    ]
        

    const context = useContext(AuthContext)

    useEffect(() => {
        let domain = window.location.hostname

        let url = window.location.pathname

       

        var prodCatId
        var prodSubCatId

        if(url.includes("cars")){
            setProdCatId('cat_d8R14zUNE')
            prodCatId = 'cat_d8R14zUNE'
        }else if(url.includes("food")){
            setProdCatId('cat_Ujt0kuFxF')
            prodCatId = 'cat_Ujt0kuFxF'
        }else if(url.includes("fashion")){
            setProdCatId('cat_skJ7HIvnc')
            prodCatId = 'cat_skJ7HIvnc'
        }else if(url.includes("product")){
            setProdCatId('cat_Ujt0kuFxY')
            prodCatId = 'cat_Ujt0kuFxY'
        }else if(url.includes("footwear")){
            setProdCatId('cat_Ujt0kuFxX')
            prodCatId = 'cat_Ujt0kuFxX'
        }else if(url.includes("fabric")){
            setProdCatId('cat_skJ7HIvnc')
            prodCatId = 'cat_skJ7HIvnc'
            setCategoryType('fabric')
            setIsThreeDRendering(true)
            if(url.includes("saree")){
                setProdSubCatId('prod_WiE3dLKOs')
                setIsThreeDRendering(false)
                prodSubCatId = 'prod_WiE3dLKOs'
                setSubCatName('saree')
            }else if(url.includes("suit")){
                setProdSubCatId('prod_ZiE6ALKwe')
                setIsThreeDRendering(false)
                prodSubCatId = 'prod_ZiE6ALKwe'
                setSubCatName('suit')
            }
        }else if(url.includes("home-furnishing")){
            setProdCatId('cat_skJ7HIvnc')
            prodCatId = 'cat_skJ7HIvnc'
            setCategoryType('homeFurnishing')
            setIsThreeDRendering(true)
            if(url.includes("curtain")){
                setProdSubCatId('prod_Ze234dhKu')
                setIsThreeDRendering(false)
                prodSubCatId = 'prod_Ze234dhKu'
                setSubCatName('curtains')
            }else if(url.includes("cushion")){
                setProdSubCatId('prod_U342qkis')
                setIsThreeDRendering(false)
                prodSubCatId = 'prod_U342qkis'
                setSubCatName('cushions')
            }
            else if(url.includes("bedsheet")){
                setProdSubCatId('prod_H12Opsu')
                setIsThreeDRendering(false)
                prodSubCatId = 'prod_H12Opsu'
                setSubCatName('bedsheet')
            }
        }




        let userEmail = cookie("emailId")
        let userId = cookie("userId")

        if(userId && userEmail && context.auth.loggedIn){
            setIsLoggedIn(true)
            getSampleImages(prodCatId,prodSubCatId)
            if(isBulk === true){
                getUserCredit()
            }else{
                getUserCreditOnce()
            }
            
        }else{
            getDummySampleImages(prodCatId,prodSubCatId)
            setIsLoggedIn(false)
        }

        getEnterpriseDetails(domain,prodCatId,prodSubCatId)

        if(!JSON.parse(sessionStorage.getItem(`isImageHide`))){
            // sessionStorage.clear()
            sessionStorage.removeItem('project_name')
            sessionStorage.removeItem('sku_name')
            sessionStorage.removeItem('isImageHide')
            sessionStorage.removeItem('isImageUploaded')
            sessionStorage.removeItem(`${random}isZipReady`)
            sessionStorage.removeItem(`${random}uploadStarted`)
            window.localStorage.removeItem(`${random}fileList`)
            
        }
        

        // set imageData from redux and pass to singleprocessing component
        if(props.tryImageDataFromRedux.imageURL || props.fileFromRedux){
            
            try {
                
                if(props.tryImageDataFromRedux.imageURL) {
                    
                    const {imageURL,subCategoryId, index,sampleImagesForCurrCategory, pageName} = props.tryImageDataFromRedux
                    handleSampleImageClick(sampleImages,imageURL,subCategoryId, index,sampleImagesForCurrCategory, pageName);
                }else if(props.fileFromRedux){
                    
                    let fileToSingleProcess = props.fileFromRedux;
                    
                    let file = {
                        file: fileToSingleProcess,
                        name: fileToSingleProcess.name,
                        size: fileToSingleProcess.size,
                        type: fileToSingleProcess.type,
                        lastModified: fileToSingleProcess.lastModified,
                        lastModifiedDate: fileToSingleProcess.lastModifiedDate,
                        url: URL.createObjectURL(fileToSingleProcess),
                        status: 'Uploading',
                        imageId: null,
                        fullResolutionOutput: null,
                        thumbnailOutput:null,
                        projectId: null,
                        skuId:null,
                        waterMarkImage:null,
                    }
    
                    if (Math.round(file.size / 1024) > 30720) {
                        return;
                    }
                    setIsBulk(false)
                    setIsImageUploaded(true)
                    setFileList([file])
                }
            } catch (error) {
                
            }


        }
        



        
        
    },[])

    const Component = (props) => {
        const {fileList} = props
        const prevAmount = usePrevious({fileList});
        useEffect(() => {
            if(prevAmount.fileList !== fileList) {
    
             // process here
            }
           
        }, [fileList])
    }


    const getPageDataFromMongo = (enterpriseId,prodCatId,prodSubCatId) => {
        
        axios({
            method : 'GET',
            url : process.env.REACT_APP_BASEURL + '/v2/self-serve/get',
            params: {
                enterprise_id: enterpriseId,
                prod_cat_id : prodCatId,
                prod_sub_cat_id : prodSubCatId
            }
        })
        .then((resp) => {
            var data = {
                angle : resp.data.frontend_data.processing_data.angle,
                backgroundBlur : resp.data.frontend_data.processing_data.background_blur,
                backgrounds : resp.data.frontend_data.processing_data.backgrounds,
                bannerImg : resp.data.frontend_data.meta_data.banner_img,
                colorEnhancements : resp.data.frontend_data.processing_data.color_enhancements,
                dealershipLogo : resp.data.frontend_data.processing_data.dealership_logo,
                heading : resp.data.frontend_data.meta_data.heading,
                marketplace : resp.data.frontend_data.processing_data.marketplace,
                numberPlate : resp.data.frontend_data.processing_data.number_plate,
                seoTitle : resp.data.frontend_data.meta_data.seo.title,
                seoDescription : resp.data.frontend_data.meta_data.seo.description,
                favIcon : resp.data.frontend_data.meta_data.seo.fav_icon,
                shadows : resp.data.frontend_data.processing_data.shadows,
                solidColorBackgrounds : resp.data.frontend_data.processing_data.solid_color_backgrounds,
                subHeading : resp.data.frontend_data.meta_data.sub_heading,
                windowCorrections : resp.data.frontend_data.processing_data.window_corrections,
                poses : resp.data.frontend_data.processing_data.poses,
                models : resp.data.frontend_data.processing_data.models,
                gifUrl : resp.data.frontend_data.meta_data.gif_url,
                isBulk : resp?.data?.frontend_data?.bulk_data?.is_bulk,
                window_tint : resp.data.frontend_data.processing_data.window_tint,
                brightness : resp.data.frontend_data.processing_data.brightness,
                body_reflection : resp.data.frontend_data.processing_data.body_reflection,
                blur_background : resp.data.frontend_data.processing_data.blur_background,
                see_through : resp.data.frontend_data.processing_data.see_through,
            }
            setFrontendData(data)
            
        })
    }

    const getEnterpriseDetails = (domain,prodCatId,prodSubCatId) => {
        axios({
            method: "GET",
            url : process.env.REACT_APP_BASEURL + "/v2/enterprise/getByCode",
            params : {
                enterprise_code : 'www.spyne.ai', //Don't change this domain.
            }
        }).then(resp => {

            if(resp?.data?.status === 200){
                document.documentElement.style.setProperty("--primaryColor",resp.data?.data?.color)
                document.documentElement.style.setProperty("--secondaryColor",resp.data?.data?.secondary_color)
                setThemeColor(resp.data?.data?.color)
                setEnterpriseName(resp.data?.data?.name)
                setFavIcon(resp.data?.data?.fav_icon_url)

                document.cookie = `enterpriseId=${resp.data?.data?.enterprise_id}; path=/`;
                document.cookie = `apiKey=${resp.data?.data?.api_key}; path=/`;
                getPageDataFromMongo(resp.data?.data?.enterprise_id,prodCatId,prodSubCatId)
            }else{
                alertify.error('Could not find enterprise details')
            }
        
            
        })
    }

    const fileUpload = async (event) => {

        // window.sessionStorage.clear()
        window.sessionStorage.removeItem('project_name')
        window.sessionStorage.removeItem('sku_name')
        window.sessionStorage.removeItem('isImageHide')
        window.sessionStorage.removeItem('isImageUploaded')
        window.sessionStorage.removeItem(`${random}isZipReady`)
        window.sessionStorage.removeItem(`${random}uploadStarted`)
        window.localStorage.removeItem('fileList')
        setIsImageUploaded(false)
        imgGenerationList.length=0
        
        fileList.length = 0
        if(prodSubCatId === 'prod_ZiE6ALKwe' || prodSubCatId === 'prod_H12Opsu'){
            window.location.reload()
        }
        multipleFileUpload(event)
        
    }

    const multipleFileUpload = (event) => {
        setDropBackground(false)

        const tempList = fileList && fileList.length ? [...fileList] : []
        let eventLength = 1
        if (frontendData.isBulk){
            eventLength = event.length
        }
        for(let i=0; i<eventLength; i++){
            if(fileList.length < 36){
                if(event.target){
                    
                    let file = {
                        file: event.target.files[i],
                        name: event.target.files[i].name,
                        size: event.target.files[i].size,
                        type: event.target.files[i].type,
                        lastModified: event.target.files[i].lastModified,
                        lastModifiedDate: event.target.files[i].lastModifiedDate,
                        url: URL.createObjectURL(event.target.files[i]),
                        status: 'Uploading',
                        imageId: null,
                        fullResolutionOutput: null,
                        thumbnailOutput:null,
                        projectId: null,
                        skuId:null,
                        waterMarkImage:null,
                    }
                    if (Math.round(file.size / 1024) > 30720) {
                        return;
                    }
                    tempList.push(file)
                    // setFileList([...fileList,file])
                }else{
                    let file = {
                        file: event[i],
                        name: event[i].name,
                        size: event[i].size,
                        type: event[i].type,
                        lastModified: event[i].lastModified,
                        lastModifiedDate: event[i].lastModifiedDate,
                        url: URL.createObjectURL(event[i]),
                        status: 'Uploading',
                        imageId: null,
                        outputImgUrl: null,
                        projectId: null,
                        skuId:null,
                        fullScreenOutput:null,
                    }
                    
                    if (Math.round(file.size / 1024) > 30720) {
                        return;
                    }
                
                    setTimeout(() => {setShowFabricCropModal(true)}, 1000);


                    tempList.push(file)
                    // setFileList([...fileList,file])
                }
                
                

                
            
            }
            else{
                setMaxUpload(true)
            }
            
            
        }
        if(tempList.length===1)
        {
            setIsBulk(false)
            setIsImageUploaded(true)
            setFileList([...tempList])
        }
        else if(tempList.length > 1){
            let userEmail = cookie("emailId")
            let userId = cookie("userId") 

            if(userId && userEmail && context.auth.loggedIn){
                setIsBulk(true)
                window.sessionStorage.setItem(`${random}isBulk`, true)
                setIsImageUploaded(true)
                window.sessionStorage.setItem(`isImageHide`, false)
                setFileList([...tempList])
            }else{
                alertify.error('Please login to continue')
            }
            
        }
        
    }

    const multipleFileUploadProject = () => {

    }

    const uploadKurti = (event) => {

        if(event.target){
            let file = {
                kurtiFile: event.target.files,
                kurtiUrl: URL.createObjectURL(event.target.files),
                
            }
            if (Math.round(file.size / 1024) > 30720) {
                return;
            }
            setKurtiImg(file)
        }else{
            let file = {
                kurtiFile: event[0],
                kurtiUrl: URL.createObjectURL(event[0]),
            }
            // let file = event[i]
            if (Math.round(file.size / 1024) > 30720) {
                return;
            }
           
            setKurtiImg(file)
            if(salwarImg !== '' && dupattaImg !== '' && prodSubCatId === 'prod_ZiE6ALKwe'){
                let fileObj = {
                    file: null,
                    name: null,
                    size: null,
                    url: null,
                    status: 'Uploading',
                    imageId: null,
                    outputImgUrl: null,
                    projectId: null,
                    skuId:null,
                    fullScreenOutput:null,
                    suitFile: event[0],
                    suitUrl: URL.createObjectURL(event[0]),
                    salwarUrl : salwarImg.salwarUrl,
                    salwarFile: salwarImg.salwarFile,
                    dupattaFile: dupattaImg.dupattaFile,
                    dupattaUrl: dupattaImg.dupattaUrl
                }
                setFileList([...fileList,fileObj])
                setIsImageUploaded(true)
            }
            else if(dupattaImg !== '' && prodSubCatId === 'prod_H12Opsu'){
                let fileObj = {
                    file: null,
                    name: null,
                    size: null,
                    url: null,
                    status: 'Uploading',
                    imageId: null,
                    outputImgUrl: null,
                    projectId: null,
                    skuId:null,
                    fullScreenOutput:null,
                    bedsheetFile: event[0],
                    bedsheetUrl: URL.createObjectURL(event[0]),
                    pillowFile: dupattaImg.dupattaFile,
                    pillowUrl: dupattaImg.dupattaUrl
                }
                setFileList([...fileList,fileObj])
                setIsImageUploaded(true)
            }

        }
        
        

    }

    const uploadDupatta = (event) => {

        if(event.target){
            let file = {
                dupattaFile: event.target.files,
                dupattaUrl: URL.createObjectURL(event.target.files),
                
            }
            if (Math.round(file.size / 1024) > 30720) {
                return;
            }
            setDupattaImg(file)
        }else{
            let file = {
                dupattaFile: event[0],
                dupattaUrl: URL.createObjectURL(event[0]),
            }
            // let file = event[i]
            if (Math.round(file.size / 1024) > 30720) {
                return;
            }
           
            setDupattaImg(file)

            if(kurtiImg !== '' && salwarImg !== '' && prodSubCatId === 'prod_ZiE6ALKwe'){
                let fileObj = {
                    file: null,
                    name: null,
                    size: null,
                    url: null,
                    status: 'Uploading',
                    imageId: null,
                    outputImgUrl: null,
                    projectId: null,
                    skuId:null,
                    fullScreenOutput:null,
                    suitFile: kurtiImg.kurtiFile,
                    suitUrl : kurtiImg.kurtiUrl,
                    salwarUrl : salwarImg.salwarUrl,
                    salwarFile: salwarImg.salwarFile,
                    dupattaFile: event[0],
                    dupattaUrl: URL.createObjectURL(event[0]),
                }
                setFileList([...fileList,fileObj])
                setIsImageUploaded(true)
            }
            else if(kurtiImg !== '' && prodSubCatId === 'prod_H12Opsu'){
                let fileObj = {
                    file: null,
                    name: null,
                    size: null,
                    url: null,
                    status: 'Uploading',
                    imageId: null,
                    outputImgUrl: null,
                    projectId: null,
                    skuId:null,
                    fullScreenOutput:null,
                    bedsheetFile: kurtiImg.kurtiFile,
                    bedsheetUrl : kurtiImg.kurtiUrl,
                    pillowFile: event[0],
                    pillowUrl: URL.createObjectURL(event[0]),
                }
                setFileList([...fileList,fileObj])
                setIsImageUploaded(true)
            }

        }


    }

    const uploadSalwar = (event) => {
        if(event.target){
            
            let file = {
                salwarFile: event.target.files,
                salwarUrl: URL.createObjectURL(event.target.files),
                
            }
            if (Math.round(file.size / 1024) > 30720) {
                return;
            }
            setSalwarImg(file)
        }else{
            let file = {
                salwarFile: event[0],
                salwarUrl: URL.createObjectURL(event[0]),
            }
            // let file = event[i]
            if (Math.round(file.size / 1024) > 30720) {
                return;
            }
           
            setSalwarImg(file)

            if(kurtiImg !== '' && dupattaImg !== '' && prodSubCatId === 'prod_ZiE6ALKwe'){
                let fileObj = {
                    file: null,
                    name: null,
                    size: null,
                    url: null,
                    status: 'Uploading',
                    imageId: null,
                    outputImgUrl: null,
                    projectId: null,
                    skuId:null,
                    fullScreenOutput:null,
                    suitFile: kurtiImg.kurtiFile,
                    suitUrl : kurtiImg.kurtiUrl,
                    salwarFile: event[0],
                    salwarUrl: URL.createObjectURL(event[0]),
                    dupattaFile: dupattaImg.dupattaFile,
                    dupattaUrl: dupattaImg.dupattaUrl
                }
                setFileList([...fileList,fileObj])
                setIsImageUploaded(true)
            }

        }

    }

    const handleApiResponse = (resp) => {
        let errorImage = 'https://i.ibb.co/kDdLtPb/Group-58938807.png';
        let file = {
            
            status: 'Done', 
            url: resp.input_image_hres_url ?? errorImage,
            imageId: resp.image_id ?? errorImage, 
            projectId: resp.project_id ?? errorImage,
            skuId: resp.sku_id,
            thumbnailOutput: resp.output_image_lres_url ?? errorImage,
            waterMarkImage: resp.watermark_image ?? errorImage,
            fullResolutionOutput: resp.output_image_hres_url ?? errorImage,
            imageName : resp.image_name ?? 'error'
        }
        setFileList([file])
        window.localStorage.setItem(`fileList`, JSON.stringify([file]))
        window.sessionStorage.setItem(`fileList`, JSON.stringify([file]))
        window.sessionStorage.setItem(`isImageUploaded`, isImageUploaded)
        
    }
    const handleBulkApiResponse = async (resp,i) => {
        let fileLists = null
        if(i!==0){
            fileLists = [...JSON.parse(window.sessionStorage.getItem(`${random}fileList`))]
            // fileLists = [...JSON.parse(cookie('fileList'))[0]]
        }else{
            fileLists = fileList
        }
        
        
        const tempList = [...fileLists.slice(0,i), Object.assign({}, fileLists[i], { 
            status: 'Done', 
            url: resp.input_image_hres_url,
            imageId: resp.image_id, 
            projectId: resp.project_id,
            skuId: resp.sku_id,
            thumbnailOutput: resp.output_image_lres_url,
            waterMarkImage: resp.watermark_image,
            fullResolutionOutput: resp.output_image_hres_url,
            imageName : resp.image_name 
        }),
            ...fileLists.slice(i+1)
        ]
       
        setFileList([...tempList])
        window.localStorage.setItem(`fileList`, JSON.stringify([tempList]))
        
        window.sessionStorage.setItem(`${random}fileList`, JSON.stringify(tempList))
        window.sessionStorage.setItem(`isImageUploaded`, isImageUploaded)
        // document.cookie = `fileList=${JSON.stringify([tempList])}; path=/`;
        
    }

    const handleErrorApiResponse = async (resp,i) => {
        let fileLists = null
        if(i!==0){
            fileLists = [...JSON.parse(window.localStorage.getItem(`fileList`))[0]]
            // fileLists = [...JSON.parse(cookie('fileList'))[0]]
        }else{
            fileLists = fileList
        }
        
        
        const tempList = [...fileLists.slice(0,i), Object.assign({}, fileLists[i], { 
            status: 'Error',
        }),
            ...fileLists.slice(i+1)
        ]
        setFileList([...tempList])
        window.localStorage.setItem(`fileList`, JSON.stringify([tempList]))
        
        window.sessionStorage.setItem(`${random}fileList`, JSON.stringify(tempList))
        window.sessionStorage.setItem(`isImageUploaded`, isImageUploaded)
        // document.cookie = `fileList=${JSON.stringify([tempList])}; path=/`;
        
    }
    const handle3DRendering = async (resp) => {
        let file = {
            thumbnailOutput: resp.output_image_lres_url,
            waterMarkImage: resp.watermark_image,
            fullResolutionOutput: resp.output_image_hres_url,
        }
        await imgGenerationList.push(file)
        setImgGenerationList(imgGenerationList)
        window.sessionStorage.setItem(`imgGenerationList`, JSON.stringify(imgGenerationList))
        if(prodSubCatId === 'prod_ZiE6ALKwe'){
            let file1 = {
                skuId: resp.sku_id,
                suitUrl : resp.input_image_hres_url.suit_img_url,
                salwarUrl: resp.input_image_hres_url.salwar_img_url,
                dupattaUrl: resp.input_image_hres_url.dupatta_img_url
            }
            setFileList([file1])
            window.localStorage.setItem(`fileList`, JSON.stringify([file1]))
        }
        else if(prodSubCatId === 'prod_H12Opsu'){
            let file1 = {
                skuId: resp.sku_id,
                bedsheetUrl : resp.input_image_hres_url.bedsheet_img_url,
                pillowUrl: resp.input_image_hres_url.pillow_img_url
            }
            setFileList([file1])
            window.localStorage.setItem(`fileList`, JSON.stringify([file1]))
        }


    }
    const handleSetCropedImgUrls = (response) => {
        let filecrop = {
            status: 'Done', 
            url: fileList[0].url,
            imageId: fileList[0].imageId, 
            projectId: fileList[0].projectId,
            skuId: fileList[0].skuId,
            thumbnailOutput: response.display_image,
            waterMarkImage: response.watermark_image,
            fullResolutionOutput: response.original,
            imageName : fileList[0].imageName 
        }
        setFileList([filecrop])
        window.localStorage.setItem(`fileList`, JSON.stringify([filecrop]))
        window.sessionStorage.setItem(`isImageUploaded`, isImageUploaded)

    }

    const getSampleImages = (prodCatId,prodSubCatId) => {
        let auth_key = cookie("auth_token")

        axios({
            method: "GET",
            url : process.env.REACT_APP_BASEURL + "/v2/product/fetchImages",
            // data : fd
            params : {
                auth_key : auth_key,
                enterprise_id: cookie('enterpriseId'),
                prod_cat_id: prodCatId,
                prod_sub_cat_id : prodSubCatId
            }
            
        })
        .then((resp) => {
            if(resp?.data?.status === 200){
                
                setSampleImages(resp?.data?.data)
                
            }else if(resp?.data?.status === 400){
                logout()
            }
        })
    }

    const getDummySampleImages = (prodCatId,prodSubCatId) => {
        let auth_key = 'fe4a909f-9e2f-461f-98fc-51c22a21aac6'
        
        axios({
            method: "GET",
            url : process.env.REACT_APP_BASEURL + "/v2/product/fetchImages",
            // data : fd
            params : {
                auth_key : auth_key,
                enterprise_id: 'TaD1VC1Ko',
                prod_cat_id: prodCatId,
                prod_sub_cat_id : prodSubCatId
            }
            
        })
        .then((resp) => {
            if(resp?.data?.status === 200){
                
                setSampleImages(resp?.data?.data)
                
            }
        })
    }

    const handleUplodedImg = (e) => {
        if (e == "Dupatta"){   
        setDupattaImg('')}
            
        else if (e == "Kurti"){
        setKurtiImg('')}
        
        else if (e == "Salwar"){
        setSalwarImg('')}
    }

    const handleSampleImageClick = (sampleImages,url,subCategory,index,sampleImagesForCurrCategory, pageName) =>{
        
        if(pageName === "home" ){
            sampleImages = sampleImagesForCurrCategory
        }
        if(subCategory === "prod_ZiE6ALKwe"){// category id of suit
            
            let fileObj = {
                file: null,
                name: null,
                size: null,
                url: null,
                status: 'Uploading',
                imageId: null,
                outputImgUrl: null,
                projectId: null,
                skuId:null,
                fullScreenOutput:null,
                suitFile: "",
                suitUrl : sampleImages[index].image_hres_url,
                salwarFile: "",
                salwarUrl:sampleImages[index].image_hres_url_1,
                dupattaFile: "",
                dupattaUrl:sampleImages[index].image_hres_url_2
            }
            setFileList([...fileList,fileObj])
            setIsImageUploaded(true)
        }else if (subCategory === "prod_H12Opsu"){
        
            let fileObj = {
                file: null,
                name: null,
                size: null,
                url: null,
                status: 'Uploading',
                imageId: null,
                outputImgUrl: null,
                projectId: null,
                skuId:null,
                fullScreenOutput:null,
                bedsheetFile: "",
                bedsheetUrl: sampleImages[index].image_hres_url,
                pillowFile: "",
                pillowUrl: sampleImages[index].image_hres_url_1
            }
            
            setFileList([...fileList,fileObj])
            setIsImageUploaded(true)
        }else if (subCategory === "prod_WiE3dLKOs" || subCategory === "prod_Ze234dhKu" || subCategory === "prod_U342qkis"){
            const fileName = 'myFile.jpg'
            let generatedFile,blob,file;

            fetch(url)
            .then(async response => {
                const contentType = response.headers.get('content-type')
                blob = await response.blob()
                generatedFile = new File([blob], fileName, { contentType })
                
                file = {
                    file: generatedFile,
                    name: generatedFile.name,
                    size: generatedFile.size,
                    type: blob.type,
                    lastModified: generatedFile.lastModified,
                    lastModifiedDate: generatedFile.lastModifiedDate,
                    url: url,
                    status: 'Uploading',
                    imageId: null,
                    outputImgUrl: null,
                    projectId: null,
                    skuId:null,
                    fullScreenOutput:null,
                }
                setFileList([file])
                setIsImageUploaded(true)
                setTimeout(() => {setShowFabricCropModal(true)}, 100);
            }).catch(()=>{

            })

        }
        else {
            let file = {
            
                url: url,
                status: 'Uploading',
                imageId: null,
                outputImgUrl: null,
                projectId: null,
                skuId:null,
                fullScreenOutput:null,
                file: null
            }
            posthog.capture('Sample Image Selected');
            setFileList([file])
            setIsSampleImage(true)
            setIsImageUploaded(true)
        }
        
    }

    const getUserCreditOnce = async () => {

        let auth_key = cookie("auth_token")
            axios({
                method: "GET",
                url : process.env.REACT_APP_BASEURL + "/v2/credit/fetch",
                params : {
                    
                    auth_key : auth_key
                }
                
            }).then((resp) => {
                
                if(resp.data.status === 401){
                    logout()
                }
                else if(resp.data.status === 200){
                    setAvailableCredit(resp.data.data.credit_available)
                    setAllotedCredit(resp?.data?.data?.credit_allotted)
                    setUsedCredit(resp?.data?.data?.credit_used)
                    setBeforeCredits(resp.data.data.credit_available)
                }
            }).catch((err) => {
                logout()
            })
    }

    const getUserCredit = async () => {
        let auth_key = cookie("auth_token") 
                const resp = await poll({
                    fn: () => {
                        
                        return axios({
                            method: "GET",
                            url : process.env.REACT_APP_BASEURL+"/v2/credit/fetch",
                            params : {
                                auth_key : auth_key
                            }
                            
                        })
                    },
                    validate: (resp) => {
                        if(resp.data.status === 200){
                            if(downloadDone === true){
                                return true
                            }else{
                                setAvailableCredit(resp.data.data.credit_available)
                                setAllotedCredit(resp?.data?.data?.credit_allotted)
                                setUsedCredit(resp?.data?.data?.credit_used)
                                setBeforeCredits(resp?.data?.data?.credit_available)
                                return false
                            }
                            
                        }else if(resp.data.status === 400){
                            document.cookie = 'emailId' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                            document.cookie = 'userId' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                            document.cookie = 'isValidated' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                            document.cookie = 'auth_token' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                            // window.sessionStorage.clear()
                            window.sessionStorage.removeItem('project_name')
                            window.sessionStorage.removeItem('sku_name')
                            window.sessionStorage.removeItem('isImageHide')
                            window.sessionStorage.removeItem('isImageUploaded')
                            window.sessionStorage.removeItem(`${random}isZipReady`)
                            window.sessionStorage.removeItem(`${random}uploadStarted`)
                            window.location.reload()
                        }
                        
                        
                    },
                    interval: 5000,
                })
    }

    const logout = () => {
        const fd = new FormData()
        fd.append('email_id', cookie('emailId'))
        fd.append('auth_token', cookie('auth_token'))
        axios({
            url: process.env.REACT_APP_BASEURL + '/v2/user/logout',
            method: 'POST',
            data: fd
        })
        .then((resp) => {
            if (resp.data?.status === 200) {
                context.loggedOut({
                    loggedIn: false,
                    user: {},
                    token: ''
                })
                document.cookie = 'emailId' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                document.cookie = 'userId' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                document.cookie = 'isValidated' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                document.cookie = 'auth_token' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                document.cookie = 'ssoToken' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                document.cookie = 'enterpriseId' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                // window.sessionStorage.clear()
                window.sessionStorage.removeItem('project_name')
                window.sessionStorage.removeItem('sku_name')
                window.sessionStorage.removeItem('isImageHide')
                window.sessionStorage.removeItem('isImageUploaded')
                window.sessionStorage.removeItem(`${random}isZipReady`)
                window.sessionStorage.removeItem(`${random}uploadStarted`)
                window.location.reload(false)
            }
        })
    }

    const handleModal = () => {
        setShowInstruction(true)
        setShowLoginModal(true)
        setUploadLogin(false)
    }

    const handleUploadLoginModal = () => {
        setShowInstruction(true)
        setShowLoginModal(true)
        setUploadLogin(true)
    }
    
    const hideLandingModal = () => {
        setShowInstruction(false)
    }

    const emptyMultipleFileArray = () => {
        setFileList([])
        setMaxUpload(false)
    }

    // Slider Const `
    const settings = {
        infinite: false,
        slidesToShow: sampleImages.length > 3 ? 3 : sampleImages.length,
        slidesToScroll: 1,
        swipeToSlide: true,
        autoplay: false,
        speed: 500,responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                dots: true
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                swipeToSlide: true,
              }
            },
            {
              breakpoint: 320,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
              }
            }
          ],
            nextArrow: <SampleNextArrow className="slider-arrow slider-prev fa fa-angle-left"/>,
            prevArrow: <SamplePrevArrow className="slider-arrow slider-next fa fa-caret-right"/>
        }; 
//End Slider

        const handleCategoryType = (url) => {
            window.location.replace(url)
        }
        
        const dragStart = (e) => {
            e.preventDefault()
            setDropBackground(true)
          }
        
        const dragLeave = (e) => {
            e.preventDefault()
            setDropBackground(false)
          }


        const updateMultipleImageList = (i) => {
            const tempList = fileList
            tempList.splice(i,1)
            setFileList([...tempList])
        }

        const updateEditedImageList = (i) => {
            const tempList = fileList
            tempList.splice(i,1)
            setFileList([...tempList])
            localStorage.setItem(`fileList`, JSON.stringify(tempList));
        }

        const removeExtraImagesFromList = () => {
            const tempList = fileList
            tempList.splice(availableCredit,fileList.length - availableCredit)
            setFileList([...tempList])
            localStorage.setItem(`fileList`, JSON.stringify(tempList));
        }


    return (
        <>
            <Helmet>
                <title>{frontendData.seoTitle}</title>
                <meta property="og:title" content={frontendData.seoTitle}/>
                <meta property="og:description" content={frontendData.seoDescription}/>
                <script async src="https://www.googletagmanager.com/gtag/js?id=UA-135505701-1"></script>
                
                
            </Helmet>
            <LoginModal />

            {!isImageUploaded ?                    
            <Dropzone  onDrop={acceptedFiles => multipleFileUpload(acceptedFiles)} onDragEnter={dragStart} onDragLeave={dragLeave}>
            {({getRootProps, getInputProps}) => (
                    <div {...getRootProps({
                        onClick: event => event.stopPropagation()
                    })} className={Styles['dropzone-main']}>
                        {dropBackground ?
                            <section className={[Styles['drop-box-text']]}>
                            <div>Drop Image Anywhere</div>  
                            
                            </section>
                            : null
                        }        
                <section className={[Styles['photo-optimizer'],''].join(' ')}>
                    <img src="https://storage.googleapis.com/spyne-website/self-serve/Automobile/bottom-blue-bg.png" className={[Styles['circle-img'],Styles['frame'],''].join(' ')}/>
                    <img src="https://storage.googleapis.com/spyne-website/self-serve/Automobile/right-blue-bg.png" className={[Styles['circle-img2'],Styles['zoom'],''].join(' ')}/>
                    <img src="https://storage.googleapis.com/spyne-website/self-serve/Automobile/dots.png" className={[Styles['dot-img'],Styles['swing'],''].join(' ')}/>
                    <div className={[Styles[''],'container-automobile'].join(' ')}>
                        <div className={[Styles[''],'row'].join(' ')}>
                            {isThreeDRendering ? 
                            <div className={[Styles['opti-title'],'col-md-6'].join(' ')}>

                                <h1>Marketplace Ready images</h1>
                                <p>Transform Images in a single click using AI<span>For Free </span></p>
                                {categoryType === 'fabric' ?
                                <img src="https://storage.googleapis.com/spyne-website/self-serve/fabric_self_serve.png" className="product-image"/>
                                :
                                <img src="https://storage.googleapis.com/spyne-website/self-serve/home-furnishing_self_serve.png" className="product-image"/>
                                }
                                
                            </div>
                            :
                            <div className={[Styles['opti-title'],'col-md-6'].join(' ')}>

                                <h1>{frontendData.heading}</h1>
                                <p>{frontendData.subHeading} <span>For free </span></p>
                                <img src={frontendData.bannerImg}/>
                            </div>
                            }
                            {isThreeDRendering ? 
                            <div className={[Styles['upload-col'],'col-md-5 offset-md-1'].join(' ')}>
                                <div className={[Styles['try-drag-drop'],'row m-0'].join(' ')}>
                                <img src="https://storage.googleapis.com/spyne-website/self-serve/Automobile/dots.png" className={[Styles['dot-img2'],Styles['swing'],''].join(' ')}/>
                    
                                    {categoryType === 'fabric' ?
                                    <div className={[Styles['types-fabric'],'col-md-12'].join(' ')}>
                                        <h4>Type of Fabric</h4>
                                        {fabrics.map((e,i) => {
                                            return (
                                                <div key={i+"fabric"} className={[Styles['types-fabric-selection'],'row m-0'].join(' ')} onClick={() => handleCategoryType(e.url)}>
                                                    <div className={[Styles['types-fabric-image'],'col-md-4'].join(' ')}>
                                                        <img src={e.img}/>
                                                    </div>
                                                    <div className={[Styles['types-fabric-content'],'col-md-8 types-fabric-content'].join(' ')}>
                                                        <h5>{e.name} <span><input type="radio" id={e.name}  name={e.name} value=""/><label for={e.name}></label>
                                                        </span></h5>
                                                    </div>
                                                </div>
                                            )
                                        })}    
                                        
                                        
                                    </div>
                                    :
                                    <div className={[Styles['types-fabric'],'col-md-12'].join(' ')}>
                                        <h4>Type of Home Furnishing</h4>
                                        {homeFurnishing.map((e,i) => {
                                            return (
                                                <div key={i+"home-furnishing"} className={[Styles['types-fabric-selection'],'row m-0'].join(' ')} onClick={() => handleCategoryType(e.url)}>
                                                    <div className={[Styles['types-fabric-image'],'col-md-4'].join(' ')}>
                                                        <img src={e.img}/>
                                                    </div>
                                                    <div className={[Styles['types-fabric-content'],'col-md-8 types-fabric-content'].join(' ')}>
                                                        <h5>{e.name} <span><input type="radio" id={e.name}  name={e.name} value=""/><label for={e.name}></label>
                                                        </span></h5>
                                                    </div>
                                                </div>
                                            )
                                        })}    
                                        
                                        
                                    </div>
                                    }

                                </div>
                                {!isLoggedIn ? 
                                    <div className={[Styles['text-signup'],'row m-0'].join(' ')}><p>Sign Up to Claim 10 Free Credits. <span onClick={handleModal}>Sign Up</span></p></div>  
                                    : null
                                }
                                
                            </div>
                            :
                            <div className={[Styles['upload-col'],'col-md-5 offset-md-1'].join(' ')}>
                                {sampleImages.length !== 0 ? 
                                <div className={[Styles['try-more'],'row m-0'].join(' ')}>
                                    <h5>No image? Try one of these: <button className={[Styles['refresh-btn'],''].join(' ')} onClick={() => getDummySampleImages(prodCatId,prodSubCatId)}><i className="fa fa-refresh" aria-hidden="true"></i></button></h5>
                                    <div className={[Styles['try-more-col'],'col-md-11 col-12'].join(' ')} >
                                        <div className={[Styles['try-more-images'],'row'].join(' ')}>
                                        <Slider {...settings} className={[Styles['automobile-slider'],'col-md-12'].join(' ')} >
                                        {
                                                sampleImages.map((e,i) => {
                                                return (
                                             
                                                <div key={i+"sample-images"} className={[Styles['try-more-col'],''].join(' ')} onClick={() => handleSampleImageClick(sampleImages,e.image_hres_url,e.prod_sub_cat_id,i)}>
                                                   <img src={e.image_url}/>
                                                </div>
                                           
                                            )
                                        })
                                    }
                                    </Slider>
                                            
                                            
                                        </div>

                                    </div> 
                                    <div className={[Styles['icons-area'],'col-md-1 col-2 d-md-block d-none'].join(' ')}>
                                        <button onClick={() => getDummySampleImages(prodCatId,prodSubCatId)}><i className="fa fa-refresh" aria-hidden="true"></i></button>
         
                                    </div>

                                </div>
                                : null
                                }
                                {prodSubCatId === 'prod_ZiE6ALKwe' || prodSubCatId === 'prod_H12Opsu'? 
                                <div className={[Styles['try-drag-drop'],Styles['fabric-drag-drop'],'row m-0'].join(' ')}>
                                     <img src="https://storage.googleapis.com/spyne-website/self-serve/Automobile/dots.png" className={[Styles['dot-img2'],Styles['swing'],''].join(' ')}/>
                    
                                    <div className={[Styles['upload-single'],prodSubCatId === 'prod_ZiE6ALKwe'? 'col-md-4':'col-md-6'].join(' ')}>
                                    {kurtiImg==''?
                                    <>
                                        {prodSubCatId === 'prod_ZiE6ALKwe'?
                                        <p>Upload Kurti</p>
                                        :
                                        <p>Upload Bedsheet</p>
                                        }
                                        <Dropzone onDrop={acceptedFiles => uploadKurti(acceptedFiles)} >
                                        {({getRootProps, getInputProps}) => (
                                            <div {...getRootProps({})} className={[Styles['dropzone1'],Styles['dropzone-img2'],'col-md-12'].join(' ')}>
                                                <img src="https://storage.googleapis.com/spyne-website/try-categories/upload-blue.gif"></img>
                                                <h6>Drag & Drop file</h6>
                                                <p><span>Browse files</span></p>
                                                <input  onChange={uploadKurti}  type="file" {...getInputProps()} />
                                            </div>
                                            )}
                                        </Dropzone> 
                                       


                                    </>
                                    :
                                    <div className={[styles['fabric-images-col'], "col-md-12"].join(' ')}>
                                        <div className={[styles['fabric-images-row'], "row"].join(' ')}>
                                            {prodSubCatId === 'prod_ZiE6ALKwe'?
                                            <p>Kurti</p>
                                            :
                                            <p>Bedsheet</p>
                                            }
                                            <img src={kurtiImg.kurtiUrl}/>
                                            <small>Preview</small>
                                            <snap onClick={()=>handleUplodedImg("Kurti")}>X</snap>
                                        </div>
                                    </div>
                                    }
                                    </div>
                                    <div className={[Styles['upload-single'],prodSubCatId === 'prod_ZiE6ALKwe'? 'col-md-4':'col-md-6'].join(' ')}> 

                                    {dupattaImg==''?
                                    <>
                                        {prodSubCatId === 'prod_ZiE6ALKwe'?
                                        <p>Upload Dupatta</p>
                                        :
                                        <p>Upload Pilow</p>
                                        }
                                        <Dropzone onDrop={acceptedFiles => uploadDupatta(acceptedFiles)} >
                                        {({getRootProps, getInputProps}) => (
                                            <div {...getRootProps({})} className={[Styles['dropzone1'],Styles['dropzone-img2'],'col-md-12'].join(' ')}>
                                                <img src="https://storage.googleapis.com/spyne-website/try-categories/upload-blue.gif"></img>
                                                <h6>Drag & Drop file</h6>
                                                <p><span>Browse files</span></p>
                                                <input  onChange={uploadDupatta}  type="file" {...getInputProps()} />
                                            </div>
                                            )}
                                        </Dropzone> 
                                    </>
                                    :
                                    <div className={[styles['fabric-images-col'], "col-md-12"].join(' ')}>
                                        <div className={[styles['fabric-images-row'], "row"].join(' ')}>
                                            {prodSubCatId === 'prod_ZiE6ALKwe'?
                                            <p>Dupatta</p>
                                            :
                                            <p>Pilow</p>
                                            }
                                            <img src={dupattaImg.dupattaUrl}/>
                                            <snap onClick={()=>handleUplodedImg("Dupatta")}>X</snap>

                                            <small>Preview</small>
                                        </div>
                                    </div>
                                    }
                                    </div>

                                    {prodSubCatId === 'prod_ZiE6ALKwe'?
                                    <div className={[Styles['upload-single'],'col-md-4'].join(' ')}> 

                                        {salwarImg==''?
                                        <>
                                        <p>Upload Salwar</p>
                                        <Dropzone onDrop={acceptedFiles => uploadSalwar(acceptedFiles)} >
                                        {({getRootProps, getInputProps}) => (
                                            <div {...getRootProps({})} className={[Styles['dropzone1'],Styles['dropzone-img2'],'col-md-12'].join(' ')}>
                                                <img src="https://storage.googleapis.com/spyne-website/try-categories/upload-blue.gif"></img>
                                                <h6>Drag & Drop file</h6>
                                                <p><span>Browse files</span></p>
                                                <input  onChange={uploadSalwar}  type="file" {...getInputProps()} />
                                            </div>
                                            )}
                                        </Dropzone> 
                                        </>
                                        :
                                        <div className={[styles['fabric-images-col'], "col-md-12"].join(' ')}>
                                            <div className={[styles['fabric-images-row'], "row"].join(' ')}>
                                                <p>Salwar</p>
                                                <img src={salwarImg.salwarUrl}/>
                                                <snap onClick={()=>handleUplodedImg("Salwar")}>X</snap>
                                                <small>Preview</small>
                                            </div>
                                        </div>
                                        }
                                    </div>
                                     :
                                     null
                                     }

                                </div>

                                :
                                <div className={[Styles['try-drag-drop'],'row m-0'].join(' ')}>
                                    <img src="https://storage.googleapis.com/spyne-website/self-serve/Automobile/dots.png" className={[Styles['dot-img2'],Styles['swing'],''].join(' ')}/>
                                    
                                     <Dropzone onDrop={acceptedFiles => multipleFileUpload(acceptedFiles)} >
                                        {({getRootProps, getInputProps}) => (
                                            <div {...getRootProps({})} className={[Styles['dropzone1'],Styles['dropzone-img'],'col-md-12 d-md-block d-none'].join(' ')}>
                                                <img src="https://storage.googleapis.com/spyne-website/try-categories/upload-blue.gif"></img>
                                                <h6>Drag & Drop file here to upload </h6>
                                                <p><span>Browse files</span></p>
                                                <input  onChange={multipleFileUpload}  type="file" {...getInputProps()} />
                                            </div>
                                        )}
                                    </Dropzone>
                                        {/* For mobile view upload Button  */}
                                        <div {...getRootProps({})} className={[Styles['dropzone1'],Styles['dropzone-img2'],'col-md-12 d-md-none d-block'].join(' ')}>
                                                <button className={[Styles['upload-sm-btn']]}><i class="fa fa-upload" aria-hidden="true"></i>  <span>Upload</span></button>
                                                <input  onChange={uploadKurti}  type="file" {...getInputProps()} />
                                            </div>
                                        {/* //For mobile view upload Button  */}
                                </div>
                                }
                                {!isLoggedIn ? 
                                    <div className={[Styles['text-signup'],'row m-0'].join(' ')}><p>Sign Up to Claim 10 Free Credits. <span onClick={handleModal}>Sign Up</span></p></div>  
                                    : null
                                }
                                
                            </div>
                            }

                        </div>

                    </div>
                </section>
                
                </div>
                        )}
                </Dropzone> 
            
                :
                <>
                    {isBulk && frontendData.isBulk?
                        <BulkImageProcessing 
                            maxUpload={maxUpload}
                            handleBulkApiResponse={handleBulkApiResponse}
                            // beforeCredits={beforeCredits}
                            multipleFileUpload={multipleFileUpload}
                            emptyMultipleFileArray={emptyMultipleFileArray}
                            multipleFileUploadProject={multipleFileUploadProject}
                            updateMultipleImageList={updateMultipleImageList}
                            // setFileList={setFileList}
                            updateEditedImageList={updateEditedImageList}
                            removeExtraImagesFromList={removeExtraImagesFromList}
                            handleErrorApiResponse={handleErrorApiResponse}
                            fileList={fileList}
                            handleApiResponse={handleApiResponse}
                            isLoggedIn={isLoggedIn}
                            category={category}
                            fileUpload={fileUpload}
                            random={random}
                            frontendData={frontendData}
                            availableCredit={availableCredit}
                            allotedCredit={allotedCredit}
                            usedCredit={usedCredit}
                            prodCatId={prodCatId}
                            handleSetCropedImgUrls={handleSetCropedImgUrls}
                            categoryType={categoryType}
                            subCatName={subCatName}
                            handle3DRendering={handle3DRendering}
                            imgGenerationList={imgGenerationList}
                            handleModal={handleModal}
                            getUserCredit={getUserCredit}
                            dropBackground={dropBackground}
                            dragStart={dragStart} 
                            dragLeave={dragLeave} 
                            isBulk={isBulk}
                            beforeCredits={beforeCredits}
                            
                        />
                        :
                        <SingleImageProcessing 
                            fileList={fileList}
                            handleApiResponse={handleApiResponse}
                            isLoggedIn={isLoggedIn}
                            category={category}
                            fileUpload={fileUpload}
                            frontendData={frontendData}
                            availableCredit={availableCredit}
                            allotedCredit={allotedCredit}
                            usedCredit={usedCredit}
                            prodCatId={prodCatId}
                            handleSetCropedImgUrls={handleSetCropedImgUrls}
                            categoryType={categoryType}
                            subCatName={subCatName}
                            random={random}
                            handle3DRendering={handle3DRendering}
                            imgGenerationList={imgGenerationList}
                            handleModal={handleModal}
                            handleUploadLoginModal={handleUploadLoginModal}
                            getUserCredit={getUserCredit}
                            dropBackground={dropBackground}
                            dragStart={dragStart} 
                            dragLeave={dragLeave} 
                            
                        />
                        
                        
                    }
                </>
            }
            

            {
                
                showLoginModal ? 
                    
                    <LoginModal
                            showInstruction={showInstruction}
                            hideModal = {hideLandingModal}
                            showLoginModal={showLoginModal}
                            uploadLogin={uploadLogin}
                        />
                    :
                    null
            }
            
            {
                showFabricCropModal && (subCatName==='saree' || subCatName==='cushions' || subCatName==='curtains') ?
                <FreeHandCropping
                showFabricCropModal={showFabricCropModal}
                fabric={fileList[0].url}
                setShowFabricCropModal={setShowFabricCropModal}
                handleCroppedFabric={handleCroppedFabric}
                fabricFile={fileList[0].file}
                />
                :
                null
            }
        </>
    )
}

// export default Sentry.withProfiler(UploadScreen)
// export default UploadScreen
const mapStateToProps = (state, ownProps)=>{
    // console.log({'state.homePageReducer redux':state.homePageReducer})
    return{
        tryImageDataFromRedux : state.homePageReducer.tryImageData,
        fileFromRedux : state.homePageReducer.file,
    }
}


export default connect(mapStateToProps, null)(UploadScreen);